import React, { useState } from 'react';
import {
  ColorPageSectionHeading,
  PageGridItem,
  PagesGridSection,
} from './styled';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { colorPageCategoryData } from './constant';
import {
  DesktopHidden,
  MobileHidden,
} from '../ProductNew/ProductDetail/styled';
import AdsBanner from '../ArticlePage/AdsBanner';
import ScrollWrapper from '../ScrollWrapper/ScrollWrapper';
import { getScreenName } from '../../Utils/helper';
import { fireClickedCard } from './utils';

const PageGrid = ({ hideHamIcon }) => {
  const router = useRouter();
  const sectionImpressionData = {
    category: 'impression_section_in_general_screen',
    screen_name: getScreenName(),
    section_name: 'Coloring Page Categories',
  };
  const [clickEffect, setClickEffect] = useState(null);
  return (
    <div>
      <MobileHidden showAPlusPlusExp>
        {!hideHamIcon && (
          <AdsBanner
            colorPage={true}
            firstLoad={true}
            minHeight="90px"
            style={{
              display: 'block',
              width: '970px !important',
              height: '90px !important',
            }}
            data-ad-slot="2482574280"
          />
        )}
      </MobileHidden>
      <DesktopHidden>
        {!hideHamIcon && (
          <AdsBanner
            firstLoad={true}
            minHeight="100px"
            data-ad-slot="2550857047"
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        )}
      </DesktopHidden>
      <br />
      <br />
      <ColorPageSectionHeading>
        Coloring Page Categories
      </ColorPageSectionHeading>
      <ScrollWrapper data={sectionImpressionData}>
        <PagesGridSection>
          {colorPageCategoryData?.map((item, index) => {
            const cardImpressionData = {
              category: 'impression_card_in_general_screen',
              screen_name: getScreenName(),
              card_name: item.title,
              section_name: 'Coloring Page Categories',
            };
            return (
              <ScrollWrapper
                data={cardImpressionData}
                key={'colorPageCategory' + index}
              >
                <PageGridItem
                  className={index == clickEffect ? 'lowOpacity' : ''}
                  squareImage={true}
                >
                  <div
                    className="imgWrapper"
                    onClick={() => {
                      fireClickedCard(item.title);
                      router.push(item?.key);
                      setClickEffect(index);
                    }}
                  >
                    <Image
                      src={item.image}
                      alt=""
                      quality={90}
                      placeholder="blur"
                      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88+F3PQAI/wNYdVMfwAAAAABJRU5ErkJggg"
                      fill
                      sizes="33vw"
                    />
                  </div>

                  <p className="title">{item.title}</p>
                  <p className="count">{`${item.totalCount} Pages`}</p>
                </PageGridItem>
              </ScrollWrapper>
            );
          })}
        </PagesGridSection>
      </ScrollWrapper>
      <br />
      <br />
      <MobileHidden showAPlusPlusExp>
        <AdsBanner
          colorPage={true}
          minHeight="90px"
          style={{
            display: 'inline-block',
            width: '970px',
            height: '90px',
          }}
          data-ad-slot="1245067126"
        />
      </MobileHidden>
      <DesktopHidden>
        {!hideHamIcon && (
          <AdsBanner
            firstLoad={true}
            minHeight="100px"
            data-ad-slot="2550857047"
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        )}
      </DesktopHidden>
    </div>
  );
};

export default PageGrid;
